// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Checkbox_wrap__2E2ul","input":"Checkbox_input__1LFgv","checkmark":"Checkbox_checkmark__3m00P","label":"Checkbox_label__gt4iq"};